import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from './../../hooks/useAuth';

/**
 * ProtectedRoute Component
 * Prevents unauthenticated users from accessing protected pages
 * Redirects to signin if not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Show minimal loading state while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        opacity: 0,
        animation: 'fadeIn 0.2s ease-in forwards'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #E5E7EB',
          borderTopColor: '#3B82F6',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />

        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          @keyframes fadeIn {
            to { opacity: 1; }
          }
        `}</style>
      </div>
    );
  }

  // Redirect to signin if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;